import { render, staticRenderFns } from "./AccountStatementPage.vue?vue&type=template&id=78b23ff1&scoped=true"
import script from "./AccountStatementPage.vue?vue&type=script&lang=js"
export * from "./AccountStatementPage.vue?vue&type=script&lang=js"
import style0 from "./AccountStatementPage.vue?vue&type=style&index=0&id=78b23ff1&prod&scoped=true&lang=css"
import style1 from "./AccountStatementPage.vue?vue&type=style&index=1&id=78b23ff1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b23ff1",
  null
  
)

export default component.exports